import { useState, useEffect } from "react";

const OTP = ({ handleChangeOtp, handleSubmit, handleResendOtp }) => {
  const [timer, setTimer] = useState(30); // 30 seconds timer
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setIsResendDisabled(false);
    }
  }, [timer]);

  const handleResend = () => {
    handleResendOtp(); // Call the resend OTP function
    setTimer(30); // Reset the timer
    setIsResendDisabled(true);
  };

  const onSubmit = (e) =>{
    e.preventDefault();
    handleSubmit();
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", backgroundColor: "#f0fff4", padding: "20px" }}>
      <div style={{ backgroundColor: "#ffffff", padding: "30px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", width: "100%", maxWidth: "400px", textAlign: "center" }}>
        <h1 style={{ color: "#28a745", fontSize: "24px", marginBottom: "10px" }}>Verify Your Email</h1>
        <p style={{ color: "#6c757d", fontSize: "16px", marginBottom: "20px" }}>
          Please check your email for the OTP and enter it below.
        </p>
        <form onSubmit={onSubmit} style={{ marginBottom: "20px" }}>
          <input
            onChange={handleChangeOtp}
            className="styledInput"
            type="text"
            placeholder="Enter OTP"
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #28a745",
              borderRadius: "4px",
              marginBottom: "10px",
              fontSize: "16px",
            }}
          />
          <button
            className="btn"
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#28a745",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Submit
          </button>
        </form>
        <p style={{ color: "#6c757d", fontSize: "14px" }}>
          Didn't receive OTP?{" "}
          <button
            onClick={handleResend}
            disabled={isResendDisabled}
            style={{
              background: "none",
              border: "none",
              color: isResendDisabled ? "#ccc" : "#28a745",
              textDecoration: "underline",
              cursor: isResendDisabled ? "not-allowed" : "pointer",
              fontSize: "14px",
            }}
          >
            Resend
          </button>
          {isResendDisabled && (
            <span style={{ marginLeft: "5px", color: "#6c757d" }}>
              in {timer}s
            </span>
          )}
        </p>
      </div>
    </div>
  );
};

export default OTP;